<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbEmployees',
  components: {},
}
</script>
